import OrderReviewTop from "./new-order-review-top";
import OrderReviewDeliveryDetails from "./new-order-review-delivery-details";
import OrderReviewItems from "./new-order-review-items";
import OrderReviewTotal from "./new-order-review-total";
import { useReactToPrint } from "react-to-print";
import { useEffect, useRef } from "react";
import InvoiceDetails from "../New-Invoice/new-invoice-details";

const NewOrderReview = (props: any) => {
  
  const componentRef = useRef(null);
  
  useEffect(() => {
    if(props.PrintEnabled)
    {
      handleOrderPrint();
    }      
  }, [props.PrintEnabled]);

  const handleOrderPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'Order Detail',
    onAfterPrint: () => props.TriggerPrint(false)
  });
  
  return (
    <>
      <div ref={componentRef} className="flex flex-column border-1 surface-border box-shadow-none m-0">
          <OrderReviewTop orderData={props.OrderData.props.orderinfo} hideEstimatedDelivery={props.hideEstimatedDelivery} />
          <OrderReviewDeliveryDetails deliveryDetails={props.OrderData} />
          <OrderReviewItems orderedItems={props.OrderData} />
          {!props.hideTotals && <OrderReviewTotal orderedItems={props.OrderData} />}
          <InvoiceDetails orderInvoice={props.OrderData} orderData={props.OrderData} />
      </div>
    </>
  );
};

export default NewOrderReview;
